import Toastr from "../../../../../itrust_common/components/Toastr";

const VISION_INSURANCE = 'VISION_INSURANCE_CLAIM_FORM_';

const DEFAULT_STATE = {
  saving: false,
  submitting: false,
  editing: {},
  visionInsuranceClaimForm: {},
  eyemedAvailableLabs: [],
  frameOptions: {
    frameManufacturer: [],
    frameBrand: [],
    frameModel: [],
    frameColor: [],
    frameEyeSize: [],
    frameTempleLength: [],
    frameSku: [],
    frameOptionsLoading: false
  },
  visionInsuranceClaimFormTemplate: []
}

let changes = null

export const visionInsuranceClaimFormReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    case `${VISION_INSURANCE}RESET`:
    case `${VISION_INSURANCE}UPDATE_PENDING`:
      return { ...state, saving: true };

    case `${VISION_INSURANCE}SUBMIT_PENDING`:
      return { ...state, submitting: true };

    case `${VISION_INSURANCE}FRAME_OPTIONS_LOAD_PENDING`:
      return { ...state, frameOptions: { ...state.frameOptions, frameOptionsLoading: true } };

    case `${VISION_INSURANCE}SUBMIT_REJECTED`:
    case `${VISION_INSURANCE}CREATE_REJECTED`:
    case `${VISION_INSURANCE}LOAD_REJECTED`:
    case `${VISION_INSURANCE}UPDATE_REJECTED`:
    case `${VISION_INSURANCE}TEMPLATE_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false, submitting: false }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}FRAME_OPTIONS_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { frameOptions: { ...state.frameOptions, frameOptionsLoading: false } }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}SUBMIT_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = { saving: false, submitting: false }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      changes = { meta: { ...response.meta }, saving: false }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}LOAD_FULFILLED`:
      changes = {
        visionInsuranceClaimForm: { ...response.insurance_claim_form },
        saving: false
      }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}FRAME_OPTIONS_LOAD_FULFILLED`:
      changes = {
        frameOptions: {
          ...state.frameOptions,
          ...response.data,
          frameOptionsLoading: false
        }
      }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}EYEMED_AVAILABLE_LABS_LOAD_FULFILLED`: {
      const labs = response?.data?.available_labs || response?.available_labs || []
      return {
        ...state,
        eyemedAvailableLabs: Array.isArray(labs) ? labs : [],
      }
    }

    case `${VISION_INSURANCE}UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.message, 201)
      changes = {
        visionInsuranceClaimForm: {
          ...response.insurance_claim_form,
          other_details: response.other_details,
          id: response.id || response.insurance_claim_form?.id,
          attachments_attributes: response.insurance_claim_form?.attachments_attributes?.length
            ? response.insurance_claim_form.attachments_attributes
            : state.visionInsuranceClaimForm.attachments_attributes,
        },
        saving: false
      }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}TEMPLATE_LOAD_FULFILLED`:
      changes = { visionInsuranceClaimFormTemplate: response['add_ons/rpa/vision_insurance/templates'], saving: false }
      return { ...state, ...changes };

    case 'VISION_INSURANCE_CLAIM_FORM_EDIT':
      changes = { editing: { ...state.editing, ...action.data } }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}EDIT_RESET`:
      changes = { editing: {} }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}RESET`:
      changes = { visionInsuranceClaimForm: {}, eyemedAvailableLabs: [] }
      return { ...state, ...changes };

    case `${VISION_INSURANCE}FRAME_OPTIONS_EDIT`:
      changes = { frameOptions: { ...state.frameOptions, ...action.data } }
      return { ...state, ...changes };

    default:
      return state
  }
}
